<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择员工"
      width="900px"
      top="8vh">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="employees"
        @select="selectEmployees"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="姓名" prop="employeeName">
            <el-input v-model.trim="filter.employeeName" placeholder="请输入员工姓名" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        filter: {
          employeeName: "",
        },
        columns: [
          {
            title: "编号",
            width: 100,
            key: "employeeNO",
            align: "center",
          },
          {
            title: "姓名",
            key: "employeeName",
            align: "center",
            width: 100,
          },
          {
            title: "性别",
            width: 100,
            key: "gender",
            align: "center",
            render: (h, params) => {
              return h("span", params.row.gender ? "女" : "男");
            },
          },
          {
            title: "部门",
            key: "departmentName",
            align: "left",
          },
          {
            title: "职位",
            key: "postName",
            align: "left",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },

      selectEmployees(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>
